export default __webpack_public_path__ + "static/media/photo--sm--food-2.d40f1c91.jpg";